import React from 'react';
import pt from 'prop-types';
import Text from '../text';
import { combine } from '/src/helpers/styles';
import * as styles from './styles.module.scss';
import { ifWordLetterLowercase } from '../../../helpers/copy';

const Button = ({
  text,
  type,
  transparent,
  className,
  onClick,
  withoutTransform,
  htmlId,
  disabled
}) => (
  <button
    onClick={onClick}
    className={combine(
      styles.button,
      styles[type],
      transparent && styles.transparent,
      disabled && styles.disabled,
      className
    )}
    id={htmlId}
    disabled={disabled}
  >
    <Text as="span" type={'button'} withoutTransform className={styles.noPointerEvents}>
      {withoutTransform ? text : ifWordLetterLowercase(text)}
    </Text>
  </button>
);

Button.propTypes = {
  text: pt.string.isRequired,
  onClick: pt.func.isRequired,
  type: pt.oneOf(['primary', 'secondary', 'tertiary', 'quaternary']).isRequired,
  className: pt.string,
  transparent: pt.bool,
  withoutTransform: pt.bool,
  htmlId: pt.string,
  htmlId: pt.bool,
};

Button.defaultProps = {
  className: '',
  transparent: false,
  htmlId: '',
  disabled: false
};

export default Button;
